var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniSchool04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 253,
    viewBox: "0 0 259 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.746094,
    y: 0.310547,
    width: 258,
    height: 252,
    fill: "#D38D8D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_502_15596",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 253
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.746094,
    y: 0.310547,
    width: 258,
    height: 252,
    fill: "#D6895E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_502_15596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.4512 145.511L199.858 192.154L301.188 146.585L165.75 93.8262L73.4512 145.511Z",
    fill: "#0C1A27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9688 135.739L223.086 181.852L303.09 146.295L171.973 100.182L91.9688 135.739Z",
    fill: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.328 112.578L222.893 154.23L286.897 125.687L171.331 84.0352L107.328 112.578Z",
    fill: "#373943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.416 90.9204L286.982 132.573L286.981 120.72L171.416 79.0684L171.416 90.9204Z",
    fill: "#4A4D5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.403 90.8948L107.479 119.41L107.479 107.584L171.402 79.0684L171.403 90.8948Z",
    fill: "#202129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.405 90.8948L168.537 92.1781L162.344 83.0981L171.405 79.0684L171.405 90.8948Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.405 90.8948L280.261 130.221V118.139L171.404 79.0684L171.405 90.8948Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.403 90.8945L274.322 128.002L270.297 129.448L168.541 92.1802L171.403 90.8945Z",
    fill: "#21232C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.084 155.182L91.9668 109.069L171.971 73.5117L303.088 119.625L223.084 155.182ZM222.978 149.261L107.412 107.609L171.416 79.0666L286.981 120.719L222.978 149.261Z",
    fill: "#CBE6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.084 155.182L91.9668 109.069L171.971 73.5117L303.088 119.625L223.084 155.182ZM222.978 149.261L107.412 107.609L171.416 79.0666L286.981 120.719L222.978 149.261Z",
    fill: "url(#paint0_linear_502_15596)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9688 109.068L223.086 155.173V181.85L91.9688 135.736V109.068Z",
    fill: "#213547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.09 119.625L223.086 155.181V181.85L303.09 146.293V119.625Z",
    fill: "#416E97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.225 100.886L242.985 135.675L249.143 132.454L154.755 98.6602L150.225 100.886Z",
    fill: "#21232C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.752 96.3574L245.637 130.566L245.637 133.841L152.752 99.6321L152.752 96.3574Z",
    fill: "#CC8259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.752 96.3571L245.637 130.566L249.353 128.629L156.468 94.4199L152.752 96.3571Z",
    fill: "#FFB287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.508 119.136L245.634 130.161L249.35 128.224L219.224 117.199L215.508 119.136Z",
    fill: "#E87F45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.844 122.487L239.443 127.579L241.525 126.499L227.926 121.406L225.844 122.487Z",
    fill: "#563320"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.888 129.577L244.555 128.819L246.638 127.738L247.063 128.368L244.888 129.577Z",
    fill: "#EC9D70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.256 122.027L244.559 128.822L244.89 129.583L239.297 127.516L238.989 127.126L225.842 122.214L226.256 122.027Z",
    fill: "#CC8259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.254 122.028L244.556 128.822L246.638 127.742L228.336 120.947L226.254 122.028Z",
    fill: "#FFB287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.25 122.028L225.859 122.207L227.942 121.126L228.333 120.947L226.25 122.028Z",
    fill: "#B88467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.632 134.33L245.631 130.16L249.347 128.223L249.349 132.392L245.632 134.33Z",
    fill: "#783814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.508 119.135L245.647 130.19V134.362L215.508 123.244V119.135Z",
    fill: "#9E4E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.402 72.6937L276.968 114.346L338.476 112.166L222.91 70.5137L161.402 72.6937Z",
    fill: "#CBE6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.402 72.6937L276.968 114.346L338.476 112.166L222.91 70.5137L161.402 72.6937Z",
    fill: "url(#paint1_linear_502_15596)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.982 124.02V114.367L161.402 72.6914L161.404 81.171L276.982 124.02Z",
    fill: "#213547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.414 242.311V222.514H190.18C194.678 222.514 197.262 225.289 197.262 229.186C197.262 233.137 194.637 235.857 190.07 235.857H186.516V242.311H182.414ZM186.516 232.549H189.414C191.848 232.549 193.037 231.182 193.023 229.186C193.037 227.217 191.848 225.891 189.414 225.877H186.516V232.549ZM201.227 242.557C199.941 242.557 198.902 241.531 198.93 240.26C198.902 239.002 199.941 237.977 201.227 237.99C202.443 237.977 203.496 239.002 203.496 240.26C203.496 241.531 202.443 242.557 201.227 242.557ZM206.832 242.311V222.514H214.598C219.096 222.514 221.68 225.289 221.68 229.186C221.68 233.137 219.055 235.857 214.488 235.857H210.934V242.311H206.832ZM210.934 232.549H213.832C216.266 232.549 217.455 231.182 217.441 229.186C217.455 227.217 216.266 225.891 213.832 225.877H210.934V232.549ZM228.242 222.514V242.311H224.195V222.514H228.242ZM238.113 242.611C233.561 242.598 230.771 239.658 230.785 234.955C230.771 230.375 233.602 227.271 237.949 227.271C241.846 227.271 244.922 229.732 244.922 234.791V235.939H234.777C234.777 238.182 236.104 239.562 238.195 239.576C239.576 239.562 240.561 238.961 240.957 238.072H244.812C244.238 240.82 241.777 242.598 238.113 242.611ZM234.777 233.396H241.094C241.08 231.592 239.836 230.293 238.031 230.307C236.172 230.293 234.859 231.688 234.777 233.396Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_502_15596",
    x1: 255.415,
    y1: 97.9126,
    x2: 240.893,
    y2: 136.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_502_15596",
    x1: 260.188,
    y1: 76.1319,
    x2: 248.363,
    y2: 105.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBE6FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniSchool04);
export default __webpack_public_path__ + "static/media/mini_school_04.9dee9794b2fbf0c5ac16c8d492e086b3.svg";
export { ForwardRef as ReactComponent };